import React, {useState} from 'react'
import {Grid} from '@material-ui/core'
import {CheckCircleOutline, Telegram, WhatsApp} from "@material-ui/icons";

import {Styles} from '../style/homeStyle'
import Nav from '../nav'
import CurrencyCalculator from './currencyCalculator'
import Tabs from './tabs'
import Currencies from './currencies'
import Golds from './golds'
import RequestForm from './requestForm'
import LocationMap from './locationMap'
import CustomerSubscriptionForm from './customerSubscriptionForm'
import BackToTop from './backToTop'
import {formatMobileNumber} from '../../utils/phoneNumber'

const Home = () => {
    const [tab, setTab] = useState('currencies')
    const primaryPhone = '09141630676'
    const secondaryPhone = '09120914659'
    const tertiaryPhone = '09337403688'
    const quaternaryPhone = '09140445267'
    const developerPhone = '09142159341'

    return (
        <>
            <Nav/>
            <Styles id="home">
                <Grid container className="sign-up">
                    <Grid item md={7} xs={12} className="content">
                        <div className="title">صرافی اسدزاده</div>
                        <div className="description">
                            خرید و فروش طلا، سکه، ارز و انجام انواع حوالجات
                        </div>
                        <CustomerSubscriptionForm/>
                    </Grid>
                    <Grid item md={5} xs={12} className="calculator-column">
                        <CurrencyCalculator/>
                    </Grid>
                </Grid>
                <div className="assets" id="rates">
                    <Tabs tab={tab} setTab={setTab}/>
                    {tab === "currencies" ? (
                        <Currencies/>
                    ) : tab === "golds" ? (
                        <Golds/>
                    ) : (
                        ""
                    )}
                </div>

                <div className="setup">
                    <div className="title">خرید، فروش، واسطه‌گری</div>
                    <div className="description">
                        در کمتر از ۵ دقیقه نرخ ارز مبدا را بررسی کرده و به نرخ مقصد تبدیل کنید.
                    </div>
                    <Grid container spacing={3}>
                        <Grid className="setup-item" item md={4} xs={12}>
                            <div className="icon">
                                <img src="/image/di_account-creation.png" alt="icon"/>
                            </div>
                            <div className="setup-item-title">ایجاد حساب کاربری</div>
                            <div className="setup-item-description">
                                اپلیکیشن صرافی اسدزاده را میتوانید از گوگل پلی و اپ استور دانلود کنید.
                            </div>
                        </Grid>
                        <Grid className="setup-item" item md={4} xs={12}>
                            <div className="icon">
                                <img src="/image/di_deposit.png" alt="icon"/>
                            </div>
                            <div className="setup-item-title">پرداخت ریالی</div>
                            <div className="setup-item-description">
                                حساب خود را با درگاه بانکی ریالی میتوانید شارژ کنید.
                            </div>
                        </Grid>
                        <Grid className="setup-item" item md={4} xs={12}>
                            <div className="icon">
                                <img src="/image/di_trade.png" alt="icon"/>
                            </div>
                            <div className="setup-item-title">معامله آنلاین</div>
                            <div className="setup-item-description">
                                در بخش معاملات میتوانید 24 ساعته به خرید و فروش بپردازید.
                            </div>
                        </Grid>
                    </Grid>
                </div>
                <Grid className="rest" container>
                    <Grid className="rest-item" item md={6} xs={12}>
                        <div className="rest-title">سادگی و امکانات در اختیار شماست</div>
                        <div className="item">
                            <CheckCircleOutline className="icon"/>
                            <div className="rest-description">
                                قیمت لحظه‌ای ارز، طلا و سکه
                            </div>
                        </div>
                        <div className="item">
                            <CheckCircleOutline className="icon"/>
                            <div className="rest-description">اپلیکیشن همراه هوشمند</div>
                        </div>
                        <div className="item">
                            <CheckCircleOutline className="icon"/>
                            <div className="rest-description">
                                امکان درخواست 24 ساعته خرید و فروش
                            </div>
                        </div>
                        <div className="item">
                            <CheckCircleOutline className="icon"/>
                            <div className="rest-description">
                                پشتیبانی 7/24 مشتریان
                            </div>
                        </div>
                    </Grid>
                    <Grid className="rest-item image" item md={6} xs={12}>
                        <img className="computer" src="/image/rest.png" alt="rest"/>
                        <img className="mobile" src="/image/rest-mobile.png" alt="rest"/>
                    </Grid>
                </Grid>
                <Grid className="connect" id="about-us" container alignItems="center">
                    <Grid className="image" item md={6} xs={12}>
                        <img
                            src="/image/exchange-front-picture.JPG"
                            alt="خدمات خرید و فروش ارز صرافی اسدزاده"
                        />
                    </Grid>
                    <Grid className="connect-content connect-content-wrapper" item md={6} xs={12}>
                        <div className="title">خدمات حضوری در کنار خدمات آنلاین</div>
                        <div className="description">
                            صرافی اسدزاده با بیش از 10 سال سابقه خدمت رسانی در حوزه خرید و فروش ارز، طلا، سکه و انجام
                            حوالجات بین المللی در کنار بیش از 5 هزار مشتری وفادار افتخار حضور دارد و همواره حفظ کیفیت
                            خدمت رسانی به شما عزیزان اولویت اول ماست.
                        </div>
                        <div className="connect-extra-image">
                            <img src="/image/exchange-front-picture-2.jpg" alt="خدمات حضوری" style={{display: 'block', maxWidth: '600px', borderRadius: '12px', boxShadow: 'none'}} />
                        </div>
                    </Grid>
                </Grid>
                <LocationMap/>
                <div id="request">
                    <RequestForm/>
                </div>
                <div className="about">
                    <div className="about-header">
                        <div className="social left">
                            <a className="social-item" href="https://wa.me/989120914659" target="_blank"
                               rel="noreferrer" aria-label="واتساپ">
                                <WhatsApp className="social-icon"/>
                            </a>
                            <a className="social-item" href="https://t.me/+989143624899" target="_blank"
                               rel="noreferrer" aria-label="تلگرام">
                                <Telegram className="social-icon"/>
                            </a>
                        </div>
                        <div className="social right">
                            <a className="social-item" href="https://wa.me/989120914659" target="_blank"
                               rel="noreferrer" aria-label="واتساپ">
                                <WhatsApp className="social-icon"/>
                            </a>
                            <a className="social-item" href="https://t.me/+989143624899" target="_blank"
                               rel="noreferrer" aria-label="تلگرام">
                                <Telegram className="social-icon"/>
                            </a>
                        </div>
                    </div>
                    <Grid className='detail' container spacing={2}>
                        <Grid className='about-description contact-details' item sm={6} xs={12}>
                            <p>آدرس اول: ماکو خیابان طالقانی روبه روی بانک صادرات ساختمان اسدزاده</p>
                            <p>آدرس دوم: بازرگان ساختمان آرارات طبقه همکف</p>
                            <p>
                                تماس:{' '}
                                <span dir="ltr">
                                    {formatMobileNumber(primaryPhone)} - 0912 0914 659 - {formatMobileNumber(tertiaryPhone)} - {formatMobileNumber(quaternaryPhone)}
                                </span>
                            </p>
                        </Grid>
                        <Grid className='about-description' item sm={6} xs={12}>
                        </Grid>
                    </Grid>
                    <div className='items'>
                        <div className='item about-description' style={{textAlign: 'center'}}>
                            © تمام حقوق محفوظ است | طراحی و توسعه توسط{' '}
                            <a className="developer-contact" tabIndex="0" href={`tel:${developerPhone}`}>پارسا آقازاده<span className="developer-phone">{formatMobileNumber(developerPhone)}</span></a>
                        </div>
                    </div>
                </div>
                <BackToTop/>
            </Styles>
        </>
    );
}
export default Home
